<div class="container">
  <div class="header-container mb-4">
    <img src="/assets/images/energy.png" class="w-100">
    <div class="centered-text">
      <p>
        49,9 MW-os hálózati energiatároló létesítése Buj településen
      </p>
    </div>
  </div>
  <div class="text-container">
    <p>
      A Buj Battery Kft. mint végső kedvezményezett 5.679 milliárd forint vissza nem térítendő támogatásban
      részesült a Magyarország Helyreállítási és Ellenállóképességi Terv keretében megjelent RRF-6.5.1-23 Hálózati
      energiatárolók telepítése energiapiaci szereplőknél című Felhívás keretében. A Buj Battery Kft. a
      RRF-6.5.1-23-2024-00023 azonosítószámú, „49,9 MW-os hálózati energiatároló létesítése Buj településen” című
      projekt
      keretében egy 49,9 MW teljesítményű, akkumulátoros villamosenergia-tároló megvalósítását tervezi megvalósítani
      Európai Uniós társfinanszírozásban.
    </p>
    <p>
      Az RRF-6.5.1-23 Hálózati energiatárolók telepítése energiapiaci szereplőknél című Felhívás célja a kiegyenlítő
      energia és kiegyenlítő kapacitás piacon potenciálisan rendelkezésre álló hálózati energiatárolásra képes
      beruházások
      ösztönzése az időjárásfüggő megújuló energiaforrások integrációjának elősegítése.
    </p>
    <p>
      A fejlesztés eredményeképp a Buj Battery Kft. összesen 49,9 MW teljesítményű, 99,8 MWh kapacitású
      akkumulátoros villamosenergia-tárolót tervez megvalósítani. A megvalósulás helyszíne Buj település külterülete. A
      Buj Battery Kft. által megvalósítandó fejlesztés célja a villamosenergia hálózat szabályozásában való
      részvétel.
    </p>
    <p>A villamosenergia tároló megvalósításának eredményeképp javul a hazai villamosenergia hálózat
      ellátásbiztonsága.</p>
    <p>A projekt tervezett befejező időpontja 2026.04.30, eddig az villamosenergia tároló aFRR akkreditációja is
      lezajlik
      a MAVIR Zrt. eljárásában.</p>
    <p>A projekt Magyarország Helyreállítási és Ellenállóképességi Tervének keretében valósul meg.</p>
  </div>
</div>
